import React from "react";
import { FaBusinessTime, FaFlag, FaHome } from "react-icons/fa";
import { FaMapLocationDot } from "react-icons/fa6";
import { GiIndiaGate } from "react-icons/gi";
import { ImLocation } from "react-icons/im";
import { LuBriefcaseBusiness } from "react-icons/lu";
import { MdHolidayVillage } from "react-icons/md";
import { SiStudyverse } from "react-icons/si";

export const menuItems = [
  {
    path: "/",
    icon: <FaHome className="text-xl" />,
    label: "DASHBOARD",
    roles: ["admin", "subadmin"],
  },
  {
    path: "/country",
    icon: <FaFlag className="text-xl" />,
    label: "COUNTRY",
    roles: ["admin", "subadmin"],
  },
  {
    path: "/state",
    icon: <GiIndiaGate className="text-xl" />,
    label: "STATE",
    roles: ["admin", "subadmin"],
  },
  {
    path: "/district",
    icon: <ImLocation className="text-xl" />,
    label: "DISTRICT",
    roles: ["admin", "subadmin"],
  },
  {
    path: "/taluka",
    icon: <FaMapLocationDot className="text-xl" />,
    label: "TALUKA",
    roles: ["admin", "subadmin"],
  },
  {
    path: "/village",
    icon: <MdHolidayVillage className="text-xl" />,
    label: "VILLAGE",
    roles: ["admin", "subadmin"],
  },
  {
    path: "/business",
    icon: <LuBriefcaseBusiness className="text-xl" />,
    label: "BUSINESS",
    roles: ["admin", "subadmin"],
  },
  {
    path: "/job",
    icon: <FaBusinessTime className="text-xl" />,
    label: "JOB",
    roles: ["admin", "subadmin"],
  },
  {
    path: "/study",
    icon: <SiStudyverse className="text-xl" />,
    label: "STUDY",
    roles: ["admin", "subadmin"],
  },
  {
    path: "/helpline-number",
    icon: <SiStudyverse className="text-xl" />,
    label: "HELP-LINE NUMBER",
    roles: ["admin", "subadmin"],
  },
  {
    path: "/donate-details",
    icon: <SiStudyverse className="text-xl" />,
    label: "Donor Details",
    roles: ["admin", "subadmin"],
  },
  {
    path: "/calendar",
    icon: <SiStudyverse className="text-xl" />,
    label: "Calendar",
    roles: ["admin", "subadmin"],
  },
  {
    path: "/relation",
    icon: <SiStudyverse className="text-xl" />,
    label: "Relation",
    roles: ["admin", "subadmin"],
  },
];
